import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quickOrders: [],          // Doctor's quick orders (for tracking)
  storeQuickOrders: [],     // Store's pending quick orders
  activeQuickOrder: null,   // QID being processed in editor
  lastQuickOrderId: "",     // Last created QID
  loading: false,
  error: null,
};

const quickOrderSlice = createSlice({
  name: "quickOrder",
  initialState,
  reducers: {
    setQuickOrders: (state, action) => {
      state.quickOrders = action.payload;
    },
    setStoreQuickOrders: (state, action) => {
      state.storeQuickOrders = action.payload;
    },
    setActiveQuickOrder: (state, action) => {
      state.activeQuickOrder = action.payload;
    },
    clearActiveQuickOrder: (state) => {
      state.activeQuickOrder = null;
    },
    setLastQuickOrderId: (state, action) => {
      state.lastQuickOrderId = action.payload;
    },
    setQuickOrderLoading: (state, action) => {
      state.loading = action.payload;
    },
    setQuickOrderError: (state, action) => {
      state.error = action.payload;
    },
    removeQuickOrder: (state, action) => {
      const qid = action.payload;
      state.quickOrders = state.quickOrders.filter(qo => qo.QID !== qid);
      state.storeQuickOrders = state.storeQuickOrders.filter(qo => qo.QID !== qid);
    },
    updateQuickOrderStatus: (state, action) => {
      const { QID, status, OID } = action.payload;
      const updateInList = (list) => list.map(qo => {
        if (qo.QID === QID) {
          return { ...qo, status, ...(OID ? { OID } : {}) };
        }
        return qo;
      });
      state.quickOrders = updateInList(state.quickOrders);
      state.storeQuickOrders = updateInList(state.storeQuickOrders);
    },
  },
});

export const {
  setQuickOrders,
  setStoreQuickOrders,
  setActiveQuickOrder,
  clearActiveQuickOrder,
  setLastQuickOrderId,
  setQuickOrderLoading,
  setQuickOrderError,
  removeQuickOrder,
  updateQuickOrderStatus,
} = quickOrderSlice.actions;

export default quickOrderSlice.reducer;
